import NavBar from "../../components/NavBar";
import { Container, MainContent } from "./style";

const Certificates = () => {

    return (
        <Container>
            <NavBar />

            <MainContent>

            </MainContent >

        </Container>
    )
}

export default Certificates;


